<ng-container *ngIf="lastSaveInfo$ | async; let lastSaveInfo">
  <ng-container
    *ngIf="
      lastSaveInfo.shouldDisplayError ||
      lastSaveInfo.shouldDisplayFailureCount ||
      lastSaveInfo.lastSave
    "
  >
    <span class="breadcrumb-divider">|</span>
    <div *ngIf="lastSaveInfo.shouldDisplayFailureCount; else elseTemplate">
      Saving failed... retrying ({{ lastSaveInfo.failureCount }}/10)
    </div>
    <ng-template #elseTemplate>
      <div [class.danger]="lastSaveInfo.shouldDisplayError">
        <span *ngIf="lastSaveInfo.shouldDisplayError">Not saved.</span>
        <ng-container *ngIf="lastSaveInfo.lastSave">
          Last saved
          <strong>{{ lastSaveInfo.lastSave }}</strong>
          ago
        </ng-container>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
